import React from 'react';
import AttackWalkthrough from '../components/AttackWalkthrough';

export default function ColonialPipeline() {
  return <AttackWalkthrough />;
}
